import React, { useState, useEffect } from 'react';
import './PortfolioSummary.css';

const PortfolioSummary = ({ commonInfo, portfolioStats, exchangeStats, totalPortfolioPnL }) => {
    const formatNumber = (num) => num.toLocaleString();
    const [usdtPrice, setUsdtPrice] = useState(() => commonInfo?.korea_USDT || '');
    
    // commonInfo가 바뀔 때마다 usdtPrice 업데이트
    useEffect(() => {
        if (commonInfo?.korea_USDT) {
            setUsdtPrice(commonInfo.korea_USDT);
        }
    }, [commonInfo]);

    if (!commonInfo) return null;

    return (
        <div className="common-info">
            <div className="basic-info">
                <div className="portfolio-stats">
                    <div className="portfolio-total">
                        <span className="total-label">포트폴리오 전체 수익:</span>
                        <span className={`total-value ${totalPortfolioPnL >= 0 ? 'positive' : 'negative'}`}>
                            {formatNumber(totalPortfolioPnL)}
                            <span className="info-unit">KRW</span>
                        </span>
                    </div>
                    <div className="portfolio-quantity">
                        <span className="label">보유 수량:</span>
                        <span className="value">
                            {formatNumber(portfolioStats?.totalQuantity || 0)}
                            <span className="info-unit">{commonInfo.symbol}</span>
                        </span>
                    </div>
                </div>
                <div className="info-item">
                    <span className="info-label">거래소:</span>
                    <span className="info-value">{commonInfo.exchange}</span>
                </div>
                <div className="info-item">
                    <span className="info-label">심볼:</span>
                    <span className="info-value">{commonInfo.symbol}</span>
                </div>
                <div className="info-item">
                    <span className="info-label">환율:</span>
                    <span className="info-value">
                        {formatNumber(commonInfo.exchange_rate)}
                        <span className="info-unit">KRW</span>
                    </span>
                </div>
                <div className="info-item">
                    <span className="info-label">테더:</span>
                    <span className="info-value">
                        {formatNumber(commonInfo.korea_USDT)}
                        <span className="info-unit">KRW</span>
                    </span>
                </div>
            </div>
            {portfolioStats && (
                <div className="exchange-totals">
                    <div className="exchange-total-group">
                        <div className="exchange-name">{commonInfo.exchange}</div>
                        <div className="total-row">
                            <span className="label">총 매수:</span>
                            <span className="value">
                                {formatNumber(portfolioStats.korea.buy)}
                                <span className="info-unit">KRW</span>
                            </span>
                        </div>
                        <div className="total-row">
                            <span className="label">총 매도:</span>
                            <span className="value">
                                {formatNumber(portfolioStats.korea.sell)}
                                <span className="info-unit">KRW</span>
                            </span>
                        </div>
                        <div className="total-row highlight">
                            <span className="label">차액:</span>
                            <span className="value">
                                {formatNumber(exchangeStats.korea.position)}
                                <span className="info-unit">KRW</span>
                            </span>
                        </div>
                        <div className="total-row highlight">
                            <span className="label">거래량:</span>
                            <span className="value">
                                {formatNumber(exchangeStats.korea.volume)}
                                <span className="info-unit">KRW</span>
                            </span>
                        </div>
                        <div className="total-row">
                            <span className="label">수수료({Number((exchangeStats.korea.feeRate * 100).toPrecision(3))}%):</span>
                            <div className="fee-values">
                                <span className="fee-value">
                                    {formatNumber(exchangeStats.korea.fee)}
                                    <span className="info-unit">KRW</span>
                                </span>
                            </div>
                        </div>
                        <div className="total-row">
                            <span className="label">차액 계산:</span>
                            <div className="position-calc">
                                <input 
                                    type="number" 
                                    value={usdtPrice} 
                                    onChange={(e) => setUsdtPrice(e.target.value)}
                                    placeholder="USDT 가격 입력"
                                    className="usdt-input"
                                />
                                <div className="position-sum">
                                    {usdtPrice ? 
                                        `한국 차액: ${formatNumber(exchangeStats.korea.position)} KRW
                                        해외 차액: ${formatNumber(exchangeStats.future.position * Number(usdtPrice))} KRW
                                        총 차액: ${formatNumber(exchangeStats.korea.position + (exchangeStats.future.position * Number(usdtPrice)))} KRW` 
                                        : '테더 가격을 입력하세요'
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="exchange-total-group">
                        <div className="exchange-name">{commonInfo.future_exchange}</div>
                        <div className="total-row">
                            <span className="label">총 매수:</span>
                            <span className="value">
                                {formatNumber(portfolioStats.future.buy)}
                                <span className="info-unit">USDT</span>
                            </span>
                        </div>
                        <div className="total-row">
                            <span className="label">총 매도:</span>
                            <span className="value">
                                {formatNumber(portfolioStats.future.sell)}
                                <span className="info-unit">USDT</span>
                            </span>
                        </div>
                        <div className="total-row highlight">
                            <span className="label">차액:</span>
                            <span className="value">
                                {formatNumber(exchangeStats.future.position)}
                                <span className="info-unit">USDT</span>
                            </span>
                        </div>
                        <div className="total-row highlight">
                            <span className="label">거래량:</span>
                            <span className="value">
                                {formatNumber(exchangeStats.future.volume)}
                                <span className="info-unit">USDT</span>
                            </span>
                        </div>
                        <div className="total-row">
                            <span className="label">수수료({Number((exchangeStats.future.feeRate * 100).toPrecision(3))}%):</span>
                            <div className="fee-values">
                                <span className="fee-value">
                                    {formatNumber(exchangeStats.future.fee)}
                                    <span className="info-unit">USDT</span>
                                </span>
                            </div>
                        </div>
                        <div className="total-row">
                            <span className="label">차액 계산:</span>
                            <div className="position-calc">
                                <input 
                                    type="number" 
                                    value={usdtPrice} 
                                    onChange={(e) => setUsdtPrice(e.target.value)}
                                    placeholder="USDT 가격 입력"
                                    className="usdt-input"
                                />
                                <div className="position-sum">
                                    {usdtPrice ? 
                                        `한국 차액: ${formatNumber(exchangeStats.korea.position / Number(usdtPrice))} USDT
                                        해외 차액: ${formatNumber(exchangeStats.future.position)} USDT
                                        총 차액: ${formatNumber((exchangeStats.korea.position / Number(usdtPrice)) + exchangeStats.future.position)} USDT` 
                                        : '테더 가격을 입력하세요'
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {portfolioStats && (
                <div className="exchange-stats">
                    <h3>테더 기준 거래 통계</h3>
                    <div className="stats-grid">
                        <div className="stats-column">
                            <div className="stats-row">
                                <span className="label">테더 구입 평단:</span>
                                <span className="value">
                                    {formatNumber(portfolioStats.korea.buy / portfolioStats.future.sell)}
                                    <span className="info-unit">KRW</span>
                                </span>
                            </div>
                            <div className="stats-row">
                                <span className="label">테더 구입 개수:</span>
                                <span className="value">
                                    {formatNumber(portfolioStats.future.sell)}
                                    <span className="info-unit">USDT</span>
                                </span>
                            </div>
                        </div>
                        <div className="stats-column">
                            <div className="stats-row">
                                <span className="label">테더 판매 평단:</span>
                                <span className="value">
                                    {formatNumber(portfolioStats.korea.sell / portfolioStats.future.buy)}
                                    <span className="info-unit">KRW</span>
                                </span>
                            </div>
                            <div className="stats-row">
                                <span className="label">테더 판매 개수:</span>
                                <span className="value">
                                    {formatNumber(portfolioStats.future.buy)}
                                    <span className="info-unit">USDT</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PortfolioSummary;
